import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

export function tagChipLabel(t: { group: string; tag: string }): JSX.Element {
  return (
    <>
      {t.group}
      <QesIcon className="align-text-top mlr5" iconName={QesIcons.ChevronRightDouble} isDecorative />
      {t.tag}
    </>
  );
}
